import { useEffect, useState } from "react";

/**
 * Hooks de layout, porteados de `imprenta` (SPEC 0003, fase 1).
 *
 * Son los dos que `AppLayout` necesita para el patrón mobile. Se portean con su
 * comportamiento exacto, no con una aproximación: el breakpoint, el cálculo del
 * ancho de la barra de scroll y la restauración en el cleanup son decisiones que
 * ya están tomadas allá.
 */

/** Por debajo de esto, el layout cambia a drawer. Es el valor de `imprenta`. */
const BREAKPOINT_MOBILE = 768;

/**
 * `true` cuando el viewport está por debajo del breakpoint.
 *
 * Usa `matchMedia` y no un listener de `resize`: el evento llega solo cuando se
 * cruza el umbral, en vez de en cada píxel que se arrastra la ventana.
 */
export function useEsMobile(): boolean {
  const [esMobile, setEsMobile] = useState(false);

  useEffect(() => {
    const consulta = window.matchMedia(`(max-width: ${BREAKPOINT_MOBILE - 1}px)`);
    const alCambiar = (e: MediaQueryListEvent | MediaQueryList) => setEsMobile(e.matches);
    alCambiar(consulta);
    consulta.addEventListener("change", alCambiar);
    return () => consulta.removeEventListener("change", alCambiar);
  }, []);

  return esMobile;
}

/**
 * Bloquea el scroll del body mientras el drawer está abierto.
 *
 * Compensa el ancho de la barra de scroll con un `padding-right`: sin eso, al
 * ocultarla el contenido salta unos píxeles hacia la derecha y la pantalla
 * "tiembla" cada vez que se abre el menú.
 */
export function useBloquearScroll(bloqueado: boolean): void {
  useEffect(() => {
    if (!bloqueado) return;

    const overflowOriginal = document.body.style.overflow;
    const paddingOriginal = document.body.style.paddingRight;
    const anchoBarra = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = "hidden";
    if (anchoBarra > 0) document.body.style.paddingRight = `${anchoBarra}px`;

    return () => {
      document.body.style.overflow = overflowOriginal;
      document.body.style.paddingRight = paddingOriginal;
    };
  }, [bloqueado]);
}
